import { render } from "./SaveEducation.vue?vue&type=template&id=5e86dd1c"
import script from "./SaveEducation.vue?vue&type=script&lang=js"
export * from "./SaveEducation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__